import { Component, OnInit, EventEmitter, OnDestroy, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { DCInput } from "../dynamic.service";

@Component({
    selector: 'prompt-dialog',
    template: `<dialog-window [title]="title" (close)="close()" modal="true" >
                <p [innerText]="message"></p>
                <form>
                    <textarea #inputElement [(ngModel)]="input" name="input" class="input-gray" placeholder="Введите значение" autofocus onfocus="this.select()" >
                    </textarea>
                </form>
                <div dialog-footer class="handler-buttons">
                    <button tabindex="3" (click)="onOk()" class="blue-button">OK</button>&nbsp;
                    <button tabindex="2" (click)="close()" class="blue-button">Отмена</button>
                </div>
              </dialog-window>`
})

export class PromptDialogComponent implements OnInit, OnDestroy, DCInput, AfterViewInit {
    /**
     * Заголовок сообщения
     */
    title = "Внимание!";
    /**
     * Текст сообщения
     */
    message = "Важное сообщение.";
    /**
     * Текст поля ввода
     */
    input = "";
    /**
     * Подписчик обработчик кнопок OK или Отмена
     */
    onOkEmitter:EventEmitter<string> = new EventEmitter();
    /**
     * Подписчик для удаления компоненты
     */
    destroyEmitter:EventEmitter<null> = new EventEmitter();
    @ViewChild("inputElement", {static: true}) inputElement:ElementRef;
    constructor() { }

    ngOnInit() { }
    ngOnDestroy(){
        this.destroyEmitter.complete();
        this.onOkEmitter.complete();
    }
    ngAfterViewInit(){
        const input = this.inputElement.nativeElement as HTMLInputElement;
        setTimeout(() => {
            input.focus();
        }, 100);
    }
    /**
     * Закрывает окно
     */
    close(){
        this.destroyEmitter.emit(null);
    }
    /**
     * Обработчик кнопки ОК
     */
    onOk(){
        this.onOkEmitter.emit(this.input);
    }
}